import { useEffect } from "react";
import { mainBus } from "@/common/buses";
import { useAppStore } from "@/common/store/appStore";

export const useHideMenusInFullscreen = () => {
  const hideAllMenus = useAppStore((state) => state.hideAllMenus);

  const hide = () => {
    hideAllMenus();
  };

  useEffect(() => {
    mainBus.on("toggle_fullscreen", hide);

    return () => {
      mainBus.off("toggle_fullscreen", hide);
    };
  }, []);
};
